import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDate'
})
// Format the date without TimeZone info
export class FormatDatePipe implements PipeTransform {

  public transform(value: string): any {

    if (value === '' || value === undefined) {
      return '';
    }

    let dateValue = new Date(value);
    let datewithouttimezone = new Date(dateValue.getUTCFullYear(),
      dateValue.getUTCMonth(),
      dateValue.getUTCDate(),
      dateValue.getUTCHours(),
      dateValue.getUTCMinutes(),
      dateValue.getUTCSeconds());
    return datewithouttimezone;
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/pipe/format-date.pipe.ts